import { UPDATE_CUSTOM_EVENT_SETTINGS_ACTION } from '../contexts';
import { INGESTION_POLICIES } from '../types';
import { DeactivateEventModal } from './DeactivateEventModal';
import { DiscardEventModal } from './DiscardEventModal';
import { SaveEventModal } from './SaveEventModal';

type Props = {
  action: UPDATE_CUSTOM_EVENT_SETTINGS_ACTION;
  setIngestionPolicyFilter: (ingestionPolicy: INGESTION_POLICIES) => void;
  eventName: string;
  onClose: () => void;
};

const INGESTION_POLICY_MODAL = {
  [UPDATE_CUSTOM_EVENT_SETTINGS_ACTION.SAVE]: SaveEventModal,
  [UPDATE_CUSTOM_EVENT_SETTINGS_ACTION.DISCARD]: DiscardEventModal,
  [UPDATE_CUSTOM_EVENT_SETTINGS_ACTION.DEACTIVATE]: DeactivateEventModal,
};

const INGESTION_POLICY_FILTER: {
  [key: string]: INGESTION_POLICIES;
} = {
  [UPDATE_CUSTOM_EVENT_SETTINGS_ACTION.SAVE]: INGESTION_POLICIES.SAVED,
  [UPDATE_CUSTOM_EVENT_SETTINGS_ACTION.DISCARD]: INGESTION_POLICIES.DISCARDED,
  [UPDATE_CUSTOM_EVENT_SETTINGS_ACTION.DEACTIVATE]: INGESTION_POLICIES.DEACTIVATED,
};

export const IngestionPolicyModals = ({ action, setIngestionPolicyFilter, ...props }: Props) => {
  const Modal = (INGESTION_POLICY_MODAL as any)[action];
  const filter = INGESTION_POLICY_FILTER[action];

  return <Modal setFilter={() => setIngestionPolicyFilter(filter)} {...props} />;
};
